import { ArrowUpRight } from 'lucide-react';
import type { AnchorHTMLAttributes, PropsWithChildren } from 'react';

type ButtonLinkProps = PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>> & {
  variant?: 'primary' | 'secondary' | 'text';
};

export function ButtonLink({ children, className = '', variant = 'primary', ...props }: ButtonLinkProps) {
  return (
    <a className={`button-link button-link--${variant} ${className}`.trim()} {...props}>
      <span>{children}</span>
      <ArrowUpRight aria-hidden="true" size={19} strokeWidth={1.8} />
    </a>
  );
}

